import { useEffect } from 'react'
import colortokensIcon from '../assets/colortokens-icon.png'

const tenantName =
  typeof window !== 'undefined' ? window.location.hostname.split('.')[0] : ''

function ColorTokensMark({ size = 34 }: { size?: number }) {
  return (
    <img
      src={colortokensIcon}
      alt="ColorTokens"
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: 'contain' }}
    />
  )
}

export default function LoginPage() {
  useEffect(() => {
    window.location.href = '/auth/login'
  }, [])

  return (
    <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-white">
      {/* Soft diagonal backdrop, same idea as the reference layout */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'linear-gradient(200deg, #e9eef7 0%, #ffffff 55%)',
        }}
      />
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-[55vh]"
        style={{
          background: 'linear-gradient(135deg, #dbe4f3 0%, #eef2fa 60%, transparent 100%)',
          clipPath: 'polygon(0 0, 100% 0, 100% 55%, 0 100%)',
        }}
      />

      {/* Top-left wordmark */}
      <div className="absolute left-8 top-8 flex items-center gap-2 sm:left-12 sm:top-10">
        <ColorTokensMark size={22} />
        <span className="text-sm font-bold tracking-wide text-[#1a1f2b]">
          COLORTOKENS<sup className="ml-0.5 text-[0.55em] font-normal text-slate-400">&reg;</sup>
        </span>
      </div>

      {/* Sign-in card */}
      <div className="relative z-10 w-full max-w-[420px] rounded-xl border border-slate-200 bg-white p-9 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_20px_40px_-16px_rgba(15,23,42,0.18)]">
        <div className="mb-7 flex items-center gap-2.5">
          <ColorTokensMark size={40} />
          <div>
            <div className="text-2xl font-extrabold tracking-tight text-[#E1251B]">
              ColorTokens<span className="align-top text-xs">&reg;</span>
            </div>
            <div className="-mt-0.5 text-lg font-bold text-[#1a1f2b]">Xshield Gateway</div>
          </div>
        </div>

        <p className="text-sm text-slate-600">
          {tenantName ? (
            <>
              Signing in to <span className="font-semibold text-[#1a1f2b]">{tenantName}</span>
            </>
          ) : (
            'Signing in to your workspace'
          )}
        </p>
        <p className="mt-1 text-xs text-slate-400">
          Redirecting you to your organization&rsquo;s identity provider…
        </p>

        <a
          href="/auth/login"
          className="mt-6 flex w-full items-center justify-center gap-2.5 rounded-md border border-[#E1251B] px-4 py-3 text-sm font-semibold uppercase tracking-wide text-[#E1251B] transition-colors hover:bg-[#fdecea]"
        >
          <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-[#E1251B]/30 border-t-[#E1251B]" />
          Continue to your identity provider
        </a>

        <p className="mt-4 text-center text-xs text-slate-400">
          Not redirected automatically?{' '}
          <a href="/auth/login" className="font-medium text-[#E1251B] hover:underline">
            Click here
          </a>
        </p>
      </div>

      <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-xs text-slate-400">
        &copy; 2026 ColorTokens. All Rights Reserved.
      </p>
    </div>
  )
}
